// const serverURL = 'http://localhost:8081/';
// const serverURL = 'http://iat.singular-it-dev.de/';
// const serverURL = 'http://iat-backend.localhost/';
//const serverURL = 'https://app.iat.v2.singular-it-test.de/';
const serverURL = 'https://gta.badminton.sport-iat.de/backend/'

export default  serverURL;
